export default {
  meta: {
    title: '踩点宝对账'
  }
};
